import React, { useEffect, useState } from 'react'
import { LanguageSelect } from '../../../constants/localization.constants'
import Button from '../button'
import GlobalContainer from '../globalContainer'
import { CustomHeaderContainer } from './style'
import { NavIcon, NavLinksMenu, NavLogo } from './subcomponents'

const uiPathURL = LanguageSelect.rows[0].href + '/'

const CustomNav = ({ headerData }: any) => {
  if (!headerData) return null
  const [openMenu, setOpenMenu] = useState<boolean>(false)
  const { logo, logoLink, ctaLink, navLinks } = headerData

  const imgURL = logo?.image?.file?.url
  const logoLinkSlugUrl = logoLink?.internalLink?.slug && uiPathURL + logoLink.internalLink.slug
  const imgSrc = logoLinkSlugUrl || '#'
  const buttonTxt = ctaLink?.ctaText || ctaLink?.text
  const ctaLinkSlugUrl = ctaLink?.internalLink?.slug && uiPathURL + ctaLink.internalLink.slug
  const buttonUrl = ctaLink?.externalUrl || ctaLinkSlugUrl || '#'

  const handleResize = () => {
    // 1024 represents sm screen width
    if (window.innerWidth > 1024) setOpenMenu(false)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const navLogo = <NavLogo imgSrc={imgSrc} altText={logo?.altText} imgUrl={imgURL} />

  const button = (
    <Button
      icon
      type={'primary'}
      theme={'light'}
      className="CustomHeader__Button"
      href={buttonUrl}
      text={buttonTxt}
      size="small"
    />
  )

  const navLinksData = <NavLinksMenu navLinks={navLinks} openMenu={openMenu} />

  return (
    <CustomHeaderContainer openMenu={openMenu} data-cy="CustomNav">
      <GlobalContainer className="CustomHeader__Wrapper">
        <div className="CustomHeader__Left">{logo && navLogo}</div>
        <div className="CustomHeader__Right">
          {navLinks && navLinksData}
          {ctaLink && button}
        </div>
        {<NavIcon openMenu={openMenu} setOpenMenu={setOpenMenu} />}
      </GlobalContainer>
    </CustomHeaderContainer>
  )
}

export default CustomNav
